/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Field, Option } from "@lib/shared/types";
import React, { ChangeEvent, ReactElement, useState } from "react";
import styles from "./styles.module.scss";
import MagnifyingGlass from "@components/svg/magnifyingGlass";
import { useDomainContext } from "@hooks/useDomainContext";

export default function Radio({
    field,
    onClick,
    value,
    className,
    primaryColor,
    ignoreOptionIcons,
    isSecondServiceForm,
    optionSelectedIndex,
    isLoading,
    showLoading,
}: {
    field: Field;
    onClick: (val: string, optionSelectedIndex: string) => void;
    value: string;
    className: string;
    primaryColor?: string;
    ignoreOptionIcons?: boolean;
    isSecondServiceForm?: boolean;
    optionSelectedIndex?: string;
    isLoading?: boolean;
    showLoading?: boolean;
}): ReactElement {
    const { domain, routeConfig } = useDomainContext();

    const variantConfig = routeConfig?.templateConfig?.variantConfig;

    const [page, setPage] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");

    const renderOptions = () => {
        const options = checkIfRadioHasMinMaxValue()
            ? gettingArrayFromMaxMinValues()
            : field.defaultValues?.options;
        const totalPages =
            options?.length && field.styles?.perPage
                ? Math.ceil(options?.length / field.styles?.perPage)
                : 1;

        const metaIcons: { [x: string]: string } | undefined = JSON.parse(
            field.meta?.icons ?? "{}",
        ) as {} | undefined;
        return (
            <>
                {field?.styles?.withSearch && (
                    <span className={styles["search-wrapper"]}>
                        <input
                            type="text"
                            onChange={(e) =>
                                setSearchQuery(e.target.value?.toLowerCase())
                            }
                            className={styles["radio-search"]}
                            placeholder="Search"
                        />
                        <MagnifyingGlass />
                    </span>
                )}
                {/* @ts-ignore */}
                {!options?.filter((x: Option) =>
                    x.label?.toString()?.toLowerCase()?.includes(searchQuery),
                )?.length && <p className="mx-auto">No Results</p>}
                {(field?.styles?.perPage
                    ? options?.slice(
                          page * field.styles?.perPage,
                          field.styles?.perPage * (page + 1),
                      )
                    : options
                )
                    ?.filter((x) => {
                        return x?.label
                            ?.toString()
                            ?.toLowerCase()
                            ?.includes(searchQuery);
                    })
                    ?.map((option, index: number) => {
                        const fieldDomainConfig =
                            domain?.config?.formFieldsConfig?.[
                                field?.codeName?.trim()
                            ]?.[option?.value?.trim()];

                        const fieldVariantConfig = variantConfig
                            ? variantConfig?.formFieldsConfig?.[
                                  field?.codeName?.trim()
                              ]?.[option?.value?.trim()]
                            : null;

                        const showIcon = !!(
                            (fieldVariantConfig?.icon ||
                                fieldDomainConfig?.icon ||
                                option?.icon ||
                                metaIcons?.[option.label]) &&
                            !ignoreOptionIcons
                        );

                        const finalIcon =
                            fieldVariantConfig?.icon ||
                            fieldDomainConfig?.icon ||
                            (option?.icon?.fullPath as string) ||
                            metaIcons?.[option.label];

                        const labelFromConfig =
                            fieldVariantConfig?.label ||
                            fieldDomainConfig?.label;

                        return (
                            <div className={styles["option"]} key={index}>
                                <input
                                    type="radio"
                                    id={`${field.codeName}-${index}`}
                                    value={option.value as string}
                                    name={field.codeName}
                                    // @ts-ignore
                                    onClick={(
                                        e: ChangeEvent<HTMLInputElement>,
                                    ) =>
                                        onClick(
                                            e.target.value,
                                            `${field.codeName}-${index}`,
                                        )
                                    }
                                    onChange={() => {}}
                                    checked={
                                        isSecondServiceForm
                                            ? option.value === value
                                            : option.value === value &&
                                              optionSelectedIndex ===
                                                  `${field.codeName}-${index}`
                                    }
                                />
                                <label
                                    key={index}
                                    htmlFor={`${field.codeName}-${index}`}
                                    className={`${
                                        option?.icon && !ignoreOptionIcons
                                            ? styles["labelWithIcon"]
                                            : ""
                                    } ${
                                        showLoading && isLoading
                                            ? styles["labelLoading"]
                                            : ""
                                    }`}
                                >
                                    {option.value === value &&
                                    showLoading &&
                                    isLoading ? (
                                        <div
                                            className={
                                                styles["loader-container"]
                                            }
                                        >
                                            <span
                                                className={styles["loader"]}
                                            ></span>
                                        </div>
                                    ) : (
                                        <>
                                            {showIcon && (
                                                <div>
                                                    <img
                                                        src={finalIcon}
                                                        alt={
                                                            (option?.label as string) ??
                                                            ""
                                                        }
                                                        className="h-8 w-auto max-w-[50px]"
                                                    />
                                                </div>
                                            )}
                                            <span
                                                className={`${
                                                    option?.icon ? "mt-2" : ""
                                                } ${
                                                    field.styles?.withTooltip
                                                        ? styles["with-tooltip"]
                                                        : ""
                                                } text-sm`}
                                            >
                                                {labelFromConfig ||
                                                    option.label}
                                            </span>
                                        </>
                                    )}
                                </label>
                            </div>
                        );
                    })}
                {totalPages > 1 && page + 1 !== totalPages && (
                    <div
                        onClick={() => setPage(page + 1)}
                        className={`${styles["option"]} cursor-pointer`}
                        style={{
                            backgroundColor: primaryColor,
                            color: "white",
                            borderColor: primaryColor,
                        }}
                    >
                        <span className="text-sm">Next</span>
                    </div>
                )}
                {page ? (
                    <div
                        onClick={() => setPage(page - 1)}
                        className={`${styles["option"]} cursor-pointer`}
                        style={{
                            color: primaryColor,
                            borderColor: primaryColor,
                            backgroundColor: "white",
                        }}
                    >
                        <span className="text-sm">Back</span>
                    </div>
                ) : null}
            </>
        );
    };

    const checkIfRadioHasMinMaxValue = () => {
        if (
            field.maxValue?.value &&
            field.minValue?.value &&
            field.maxValue.type === "number" &&
            field.minValue.type === "number" &&
            field.maxValue.value > field.minValue.value
        ) {
            return true;
        }
        return false;
    };

    const gettingArrayFromMaxMinValues = () => {
        const newArray = [];
        for (
            let i: number = parseInt(field.minValue?.value as string, 10);
            i <= parseInt(field.maxValue?.value as string, 10);
            i++
        ) {
            newArray.unshift({
                label: i,
                value: `${i}`,
                icon: null,
            });
        }

        return newArray;
    };

    return (
        <div
            className={`${styles["field"]} ${styles["radio"]} ${
                className ?? ""
            }`}
        >
            {renderOptions()}
        </div>
    );
}
